module.exports = (
  $scope,
  $uibModalInstance,
) ->

  $scope.cancel = ->
    $uibModalInstance.dismiss "cancel"
    return

  $scope.onConfirm = ->
    $uibModalInstance.close true
    return
